var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "my-4" }, [
    _c("div", { staticClass: "div-container" }, [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-12 col-md-3" }, [
          _c("div", { staticClass: "d-flex" }, [
            _c("div", { staticClass: "label" }, [_vm._v("Tipo de Programa:")]),
            _c("div", [_vm._v(_vm._s(_vm.item.programType.name))])
          ])
        ]),
        _c("div", { staticClass: "col-12 col-md-2" }, [
          _c("div", { staticClass: "d-flex" }, [
            _c("div", { staticClass: "label" }, [_vm._v("Programa:")]),
            _c("div", [_vm._v(_vm._s(_vm.item.program.name))])
          ])
        ]),
        _c("div", { staticClass: "col-12 col-md-2" }, [
          _c("div", { staticClass: "d-flex" }, [
            _c("div", { staticClass: "label" }, [_vm._v("Presupuesto:")]),
            _c("div", [_vm._v(_vm._s(_vm._f("price")(_vm.item.projectedFund)))])
          ])
        ]),
        _c("div", { staticClass: "col-12 col-md-4" }, [
          _c("div", { staticClass: "d-flex" }, [
            _c("div", { staticClass: "label" }, [_vm._v("Número de Cifra:")]),
            _c("div", [_vm._v(_vm._s(_vm.fullNumber))])
          ])
        ]),
        !_vm.isReadOnly
          ? _c("div", { staticClass: "col-md-1 text-right" }, [
              _c("i", {
                staticClass: "fal fa-times-circle text-danger",
                on: {
                  click: function($event) {
                    return _vm.remove(_vm.item)
                  }
                }
              })
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }